import React from 'react';
import moment from 'moment';
//import tobeor from 'tobeor';

import Checkbox from '@mui/material/Checkbox';
import LocationIcon from '@mui/icons-material/LocationOnOutlined';

export default ({
  rst,
  trpl,
  style,
  nodeId,
  classes,
  trplSaveDataImport,
}) => {
  let formattedDate = '';
  let additions = '';
  let valFuzzy = '';
  const isUrl = trpl.type === 'URL';
  const isDate = trpl.type === 'DATE';
  const isTime = trpl.type === 'TIME';
  //const isInteger = tobeor(trpl.type, ['INTEGER', 'FLOAT']);
  const isFile = trpl.type === 'FILE' || trpl.type === 'IMAGE';
  const isDateAndTime = trpl.type === 'DATE_AND_TIME';
  const isGeolocation = trpl.type === 'GEOLOCATION' || trpl.type === 'TELEGRAM_LOCATION';

  if (isDate || isDateAndTime || isTime) {
    const date = rst.locale_correction ? moment(+trpl.val) : moment(+trpl.val).utcOffset(0);

    const dateFormat = isDate ? 'DD MMM YYYY' : isDateAndTime ? 'DD MMM YYYY HH:mm' : isTime ? 'HH:mm' : '';
    formattedDate = dateFormat ? date.format(dateFormat) : '';
  }
  if (trpl.tz || trpl.units) {
    const addition = trpl.tz ? trpl.tz : trpl.units;
    additions = <span style={{ fontSize: 10, color: '#878787' }}>{addition}</span>;
  }
  if (trpl.val_fuzzy) {
    valFuzzy = <span style={{ fontSize: 10, color: '#878787' }}>&ldquo;{trpl.val_fuzzy}&rdquo;</span>;
  }

  const trplWhiteSpace =
    isFile || isUrl || (rst.render_parts && !trpl.val) || (trpl.val && trpl.val.length < 30)
      ? 'nowrap'
      : 'normal';

  const trplStyle = trpl.virtual && trpl.val === undefined ? 'italic' : 'normal';

  const booleanRendererForTrue = (!rst.renderer || (rst.renderer && !rst.renderer.hasOwnProperty('true'))) ? true : rst.renderer && rst.renderer.hasOwnProperty('true') ? rst.renderer.true : null;
  const booleanRendererForFalse = (!rst.renderer || (rst.renderer && !rst.renderer.hasOwnProperty('false'))) ? false : rst.renderer && rst.renderer.hasOwnProperty('false') ? rst.renderer.false : null;

  const booleanIconForTrue = rst.renderer && rst.renderer.hasOwnProperty('true_icon') ? true : false;
  const booleanIconForFalse = rst.renderer && rst.renderer.hasOwnProperty('false_icon') ? true : false;

  const editableCheckboxRenderer = rst.renderer && rst.renderer.hasOwnProperty('editable_checkbox') ? rst.renderer.editable_checkbox : false;

  let trplTextValue;
  if (rst && rst.type === 'BOOLEAN') {

    if (trpl.val) {
      if (booleanRendererForTrue === "" && !booleanIconForTrue) return null;

      trplTextValue =
        booleanRendererForTrue && booleanRendererForTrue === 'rst_title'
          ? rst.title
          : String(booleanRendererForTrue);
      
      if (trplTextValue === '' && !valFuzzy && !booleanIconForTrue) return null;

    } else if (!trpl.val || trpl.val === false) {
      if (booleanRendererForFalse === "" && !booleanIconForFalse) return null;

      trplTextValue =
        booleanRendererForFalse && booleanRendererForFalse === 'rst_title'
          ? rst.title
          : booleanRendererForFalse && booleanRendererForFalse === `not 'rst_title'`
            ?  `not ${rst.title}`
            : String(booleanRendererForFalse);

      if (trplTextValue === '' && !valFuzzy && !booleanIconForFalse) return null;
    }

  } else {
    trplTextValue =
      rst.render_parts && !trpl.val && !trpl.virtual
        ? 'no calc'
        : isFile && trpl.metadata && trpl.metadata && trpl.metadata._val
          ? trpl.metadata._val.url
          : trpl.val === null || trpl.val === undefined || trpl.val === ''
          ? '\u200B'
            : isDate || isDateAndTime || isTime
              ? formattedDate
              : trpl.val;
  }

  return (
    <div key="trpl" style={{ ...style, height: '21px', width: editableCheckboxRenderer ? '21px' : 'auto' }} className={classes.trplContainer}>
      <div
        className={classes.trplValue}
        style={{
          color: '#181616',
          fontStyle: trplStyle,
          whiteSpace: trplWhiteSpace,
          backgroundColor: `${
            (trpl.warnings && trpl.warnings.length)
            ? '#FFD3B5' : trpl.virtual
            ? '#def0f5' : false//!isEmbed
            ? 'rgb(242 230 225 / 65%)' : ''
            //? '#F2EEE1' : ''
          }`,
        }}
      >
        {isFile || isUrl ?
          <a
            style={{
              color: '#596686',
              textDecoration: 'underline',
            }}
            target="blank"
            href={isFile ? trpl.metadata._val.url : trpl.val}
          >
            {trplTextValue}
          </a>
          : isGeolocation && trpl.val ? <LocationIcon fontSize='small' />
            : <div className={classes.alignCenter}>
                {(booleanIconForTrue && trpl.val) || (booleanIconForFalse && (!trpl.val || trpl.val === false)) ?
                  <Checkbox
                    size='small'
                    color='default'
                    checked={trpl.val}
                    className={`${editableCheckboxRenderer ? classes.checkboxBooleanEditable : classes.checkboxBoolean}`}
                    style={{ pointerEvents: editableCheckboxRenderer ? '' : 'none' }}
                    onChange={(e) => {
                      trplSaveDataImport(nodeId, rst, e.target.checked, rst.type === 'BOOLEAN', trpl && trpl.tid ? trpl.tid : undefined);
                    }}
                  />
                : null}

                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 500,
                    marginLeft: '3px',
                    transform: 'translateZ(0)',
                    backfaceVisibility: 'hidden',
                    MozOsxFontSmoothing: 'auto',
                    textRendering: 'optimizeLegibility',
                    WebkitFontSmoothing: 'subpixel-antialiased'
                  }}
                  title={trplTextValue} className={classes.nowrap}>{trplTextValue} {additions} {valFuzzy}</span>
              </div>
            || " "
        }
      </div>
    </div>
  );
};
